// This import loads the firebase namespace along with all its type information.
import Translation from './translation-model'

export async function load_translations(): Promise<Translation[]> {
  throw 'Not implemented'
}

export async function delete_translation(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_translation(): Promise<Translation> {
  throw 'Not implemented'
}
